import clsx from 'clsx';
import useAuth from 'hooks/useAuth';
import { FC } from 'react';
import { IMenuTypes } from 'utils/models';

// components
import SideActions from './SideActions';
import {
  SvgCoupon,
  SvgInbox,
  SvgOrders,
  SvgPrescription,
  SvgProfile,
  SvgSideBox,
  SvgSideHealth,
  SvgSideVideo,
  SvgUserManagement
} from './SvgIcons';

const SideBar: FC = () => {
  const { user } = useAuth();

  const links: IMenuTypes[] = [];

  if (
    user?.is_super_admin ||
    user?.user_type?.patient_access ||
    user?.user_type?.login_patient_access
  ) {
    links.push({
      label: 'Patients',
      to: '/patients',
      icon: <SvgProfile className="w-5 h-5 text-black" />
    });
  }

  if (
    user?.is_super_admin ||
    user?.user_type?.doctor_access ||
    user?.user_type?.login_doctor_access
  ) {
    links.push({
      label: 'Doctors',
      icon: <SvgSideHealth className="w-5 h-5 text-black" />,
      actions: [
        { label: 'Doctor List', to: '/doctors' },
        { label: 'Doctor Types Management', to: '/doctor-types' },
        { label: 'Doctor Consultation Types Management', to: '/doctor-consultation-types' }
      ],
      activeMatches: ['/doctor-types', '/doctor-consultation-types']
    });
  }

  if (
    user?.is_super_admin ||
    user?.user_type?.consultation_access ||
    user?.user_type?.reset_consultation_access ||
    user?.user_type?.generate_prescription_access ||
    user?.user_type?.reschedule_access ||
    user?.user_type?.did_not_attend_access ||
    user?.user_type?.cancel_access ||
    user?.user_type?.consultation_logs_access
  ) {
    links.push({
      label: 'Consults',
      to: '/consultations',
      icon: <SvgSideVideo className="w-5 h-5 text-black" />
    });
  }

  if (user?.is_super_admin || user?.user_type?.product_access) {
    links.push({
      label: 'Products',
      icon: <SvgSideBox className="w-5 h-5 text-black" />,
      actions: [
        { label: 'Product List', to: '/products' },
        { label: 'Product Management', to: '/product-category' }
      ]
    });
  }

  if (user?.is_super_admin ||
    user?.user_type?.patient_access ||
    user?.user_type?.login_patient_access) {
    links.push(
      {
        label: 'Prescriptions',
        to: '/prescriptions',
        icon: <SvgPrescription className="w-5 h-5 text-black" />
      },
      { label: 'Inbox', to: '/inbox', icon: <SvgInbox className="w-5 h-5 text-black" /> }
    );
  }

  if (user?.is_super_admin || user?.user_type?.prescription_access) {
    links.push({
      label: 'Orders',
      to: '/orders',
      icon: <SvgOrders className="w-5 h-5 text-black" />
    });
  }

  if (user?.is_super_admin || user?.user_type?.coupon_access) {
    links.push({
      label: 'Coupons',
      to: '/coupons',
      icon: <SvgCoupon className="w-5 h-5 text-black" />
    });
  }

  if (user?.is_super_admin) {
    links.push({
      label: 'User Management',
      icon: <SvgUserManagement className="w-5 h-5 text-black" />,
      actions: [
        {
          label: 'User Access Management',
          to: '/users'
        },
        {
          label: 'User Types Management',
          to: '/user-types'
        },
        {
          label: 'Payment Transactions',
          to: '/payment-transactions'
        },
      ]
    });
  }

  return (
    <div className="hidden md:block bg-white h-full">
      <div className={clsx('bg-white h-full relative px-2 pt-2')}>
        <div className="pt-4 ">
          <SideActions actions={links} isCollapse />
        </div>
      </div>
    </div>
  );
};

export default SideBar;
